export default __webpack_public_path__ + "static/media/tip16.cc982614.png";